// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Tokelau from '../_raw/flag/icon_flag_tokelau.png';

export default () => <img src={Tokelau} alt="Tokelau" />;
